const EaglesMade = (prop) => {
  const { count, show, orientation = 'landscape' } = prop;

  return (
    <div style={{...styles.container, ...(orientation === 'portrait' ? styles.containerPortrait : {}), ...(show ? styles.show : {})}}>
      <p style={{...styles.content, ...(orientation === 'portrait' ? styles.contentPortrait : {})}}>So far, <br style={{ display: (orientation !== 'portrait' ? 'none' : 'block') }} />{count > 0 ? count : 'no'} eagle{count == 1 ? '' : 's'}< br/>{count == 1 ? 'has' : 'have'} been <br style={{ display: (orientation !== 'portrait' ? 'none' : 'block') }} />made</p>
    </div>
  );
};

const styles = {
  container: {
    color: '#ffffff',
    fontFamily: 'MorganStanley',
    fontSize: '1.8em',
    fontWeight: 'bold',
    textAlign: 'center',

    position: 'absolute',
    top: '0',
    left: '0',
    bottom: '0',
    right: '0',

    display: 'flex',
    alignItems: 'end',
    justifyContent: 'center',

    opacity: '0',
    transition: 'opacity 1s'
  },

  containerPortrait: {
    fontSize: '4.1em'
  },

  content: {
    lineHeight: '1.1em',
    marginBottom: '10vh'
  },

  contentPortrait: {
    lineHeight: '1em',
    marginBottom: '6vh'
  },

  show: {
    opacity: '1'
  }
};

export default EaglesMade;